

export default {
  props: {
    diagram: { type: Object, required: true }
  },
  computed: {
    jsonld () {
      return {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: this.diagram.title,
        image: [
          this.diagram.image.full_size.png,
          this.diagram.image.full_size.webp,
          this.diagram.image.medium.png,
          this.diagram.image.medium.webp,
          this.diagram.image.small.png,
          this.diagram.image.small.webp
        ],
        description: this.stripHtml(this.diagram.abstract || ''),
        offers: {
          '@type': 'Offer',
          availability: 'https://schema.org/InStock',
          price: this.diagram.price,
          priceCurrency: 'USD',
          url: `${this.$config.frontendHost}/diagrams/${this.diagram.url}/`
        },
        sku: this.diagram.id,
        brand: {
          '@type': 'Brand',
          logo: this.logoPath,
          name: 'infoDiagram.com',
          url: this.$config.frontendHost
        }
      }
    },
    logoPath () {
      const image = require('~/assets/images/infoDiagram-logo-top-banner.png')
      return `${this.$config.frontendHost}${image}`
    }
  },
  methods: {
    stripHtml (html) {
      return html.replace(/<\/?[^>]+>/ig, ' ').replace(/\n/ig, '').replace(/\s+/ig, ' ').trim()
    }
  }
}
